module.exports = global["$"] = require("-!C:\\_PROJECTS\\HtmlProjects\\cities-future-2017\\node_modules\\expose-loader\\index.js?jQuery!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/expose-loader?jQuery!./~/jquery/dist/jquery.js
// module id = 97
// module chunks = 0